/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './UserPaymentMethod-ActionType';

export const loadMostUsedPaymentMethods = (data) => ({
    type: actionTypes.LOAD_MOST_USED,
    data,
});

export const userSelectPaymentMethod = () => ({
    type: actionTypes.IS_USER_SELECTED_PAYMENT_METHOD,
});

export const selectPersonalizedPaymentMethod = (payload) => ({
    type: actionTypes.IS_PERSONLAIZED_PAYMENT_METHOD_SELECTED,
    payload,
});

export default {};
